import { LwBlockGridContainer } from 'redesign';
import { Box, Grid } from '@mui/material';
import { LwCard } from 'redesign/card/card';
import { DashboardAnalyticsResponse } from 'api/services/dashboard/dashboard-service.schema';
import { useMemo } from 'react';
import { LwCardProps } from 'redesign/card/card.types';
import { HeaderComponent } from '../shared/components/header-component';

export const AnalyticsSection = ({ data }: { data: DashboardAnalyticsResponse | undefined }) => {
  const mappedData = useMemo(() => analyticsDataMapper(data), [data]);

  return (
    <Box>
      <HeaderComponent titleText="Analytics" downloadUrl="#" />
      <LwBlockGridContainer>
        {mappedData.map((cardData) => (
          <Grid item xs={6} md={6} lg={6} key={cardData.primaryText} aria-label="card-element">
            <LwCard {...cardData} />
          </Grid>
        ))}
      </LwBlockGridContainer>
    </Box>
  );
};

const analyticsDataMapper = (data: DashboardAnalyticsResponse | undefined): LwCardProps[] => {
  return [
    {
      primaryText: 'Aanmeldingen',
      status: 'in afwachting',
      subheaderText: 'Komende 14 dagen',
      primaryValue: data ? `${data.applicationsPendingReview}` : '',
      secondaryValue: data ? `${data.applicationAverageReactionTime} dagen` : '',
      secondaryText: 'Gemiddelde reactietijd',
      threshold: { low: 3, high: 6 },
      isGradient: true,
      isFillRateCard: false,
    },
    {
      primaryText: 'Openstaande checkouts',
      status: '',
      subheaderText: 'Afgelopen 14 dagen',
      primaryValue: data ? `${data.checkoutsPendingReview}` : '',
      secondaryValue: data ? `${data.checkoutsAverageAcceptenceTime} dagen` : '',
      secondaryText: 'Gemiddelde acceptatietijd',
      threshold: { low: 3, high: 5, thresholdInverted: true },
      isGradient: false,
      isFillRateCard: false,
    },
    {
      primaryText: 'Fill-rate',
      status: 'van aankomende diensten',
      subheaderText: 'Komende 14 dagen',
      primaryValue: data ? `${data.fillRateOfUpcomingShifts}` : '',
      secondaryValue: data ? `${data.fillRateForFlexPoolWorkers} %` : '',
      secondaryText: 'Vanuit de flexpool',
      threshold: { low: 90, high: 97.5 },
      isGradient: false,
      isFillRateCard: true,
    },
    {
      primaryText: 'Dagen',
      status: 'vooruit gepland',
      subheaderText: undefined,
      primaryValue: data ? `${data.daysPlannedAhead}` : '',
      secondaryValue: data ? `${data.medianShiftPublishingWindow} dagen` : '',
      secondaryText: 'Aantal dagen tussen planmomenten',
      threshold: { low: 14, high: 21 },
      isGradient: true,
      isFillRateCard: false,
    },
  ];
};
